import React from 'react';

export function ExternalEmailSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icons">
        <path
          id="Vector"
          d="M8.66732 12.6665C8.66732 10.4598 10.4607 8.6665 12.6673 8.6665C13.4007 8.6665 14.0807 8.8665 14.6673 9.2065V3.99984C14.6673 3.64622 14.5268 3.30708 14.2768 3.05703C14.0267 2.80698 13.6876 2.6665 13.334 2.6665H2.66732C1.92732 2.6665 1.33398 3.25984 1.33398 3.99984V11.9998C1.33398 12.3535 1.47446 12.6926 1.72451 12.9426C1.97456 13.1927 2.3137 13.3332 2.66732 13.3332H8.72732C8.69398 13.1132 8.66732 12.8932 8.66732 12.6665ZM2.66732 5.33317V3.99984L8.00065 7.33317L13.334 3.99984V5.33317L8.00065 8.6665L2.66732 5.33317ZM13.334 14.6665V13.3332H10.6673V11.9998H13.334V10.6665L15.334 12.6665L13.334 14.6665Z"
          fill="#5BC4BF"
        />
      </g>
    </svg>
  );
}

export function SendFormSVG() {
  return (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icons">
        <path
          id="Path / file-send"
          d="M9.15462 1.00003H3.43544C3.24657 0.998751 3.05933 1.03418 2.88458 1.10426C2.70984 1.17433 2.55108 1.27767 2.41753 1.40825C2.28398 1.53883 2.1783 1.69407 2.10663 1.86493C2.03495 2.03579 1.99872 2.21887 2.00003 2.40354V13.5965C2.00003 13.7808 2.03716 13.9633 2.1093 14.1336C2.18143 14.3039 2.28716 14.4586 2.42045 14.5889C2.55374 14.7193 2.71198 14.8226 2.88613 14.8932C3.06028 14.9637 3.24694 15 3.43544 15H12.0209C12.2094 15 12.3961 14.9637 12.5702 14.8932C12.7444 14.8226 12.9026 14.7193 13.0359 14.5889C13.1692 14.4586 13.2749 14.3039 13.3471 14.1336C13.4192 13.9633 13.4563 13.7808 13.4563 13.5965V5.19739L9.15462 1.00003ZM8.11037 13.1518V11.7483H5.24853V10.3605H8.11037V8.95703L10.2536 11.0597L8.10678 13.1518M8.43602 5.89739V2.05266L12.3708 5.90002L8.43602 5.89739Z"
          fill="#5BC4BF"
        />
      </g>
    </svg>
  );
}

export function FelixSurveySVG() {
  return (
    <svg
      width="400"
      height="300"
      viewBox="0 0 600 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="600" height="300" rx="18.75" fill="#EBF8F7" />
      <path
        d="M131.213 149.086C113.817 136.018 112.889 126.315 118.15 119.153C123.404 111.992 132.856 110.088 150.253 123.163C167.649 136.231 186.397 159.33 181.135 166.484C175.881 173.645 148.609 162.153 131.213 149.086Z"
        fill="url(#paint0_linear_24589_17118)"
      />
      <path
        d="M49.5886 145.061C52.199 111.884 75.6378 103.714 103.594 105.845C131.55 107.976 153.433 119.599 150.823 152.777C148.213 185.954 122.101 228.109 94.1449 225.978C66.1888 223.847 46.9783 178.231 49.5886 145.061Z"
        fill="url(#paint1_linear_24589_17118)"
      />
      <path
        d="M46.8464 138.6C55.803 118.861 65.0878 115.876 73.2472 119.461C81.4066 123.045 85.3456 131.846 76.389 151.584C67.4325 171.323 48.98 194.539 40.8128 190.954C32.6456 187.37 37.8898 158.346 46.8464 138.6Z"
        fill="url(#paint2_linear_24589_17118)"
      />
      <path
        d="M61.6752 71.0271C61.0159 91.5804 85.0074 98.4528 114.844 99.3696C144.681 100.286 169.069 94.8961 169.728 74.3505C170.388 53.8049 147.07 25.8635 117.233 24.9467C87.3969 24.0299 62.3345 50.4738 61.6751 71.0194L61.6752 71.0271Z"
        fill="url(#paint3_linear_24589_17118)"
      />
      <path
        d="M74.1728 67.0036C72.946 82.7812 91.1552 88.8762 114.064 90.5894C136.974 92.3027 155.911 88.9835 157.137 73.2059C158.364 57.4283 141.406 35.1629 118.497 33.4496C95.588 31.7364 75.3997 51.226 74.1728 67.0036Z"
        fill="url(#paint4_linear_24589_17118)"
      />
      <path
        d="M101.305 76.724C103.208 76.7568 104.777 75.2648 104.81 73.3915C104.842 71.5182 103.326 69.973 101.423 69.9402C99.5194 69.9074 97.9502 71.3994 97.9177 73.2727C97.8851 75.146 99.4017 76.6912 101.305 76.724Z"
        fill="white"
      />
      <path
        d="M138.49 73.972C140.394 74.0048 141.963 72.5128 141.995 70.6395C142.028 68.7663 140.511 67.2211 138.608 67.1883C136.705 67.1555 135.136 68.6475 135.103 70.5208C135.071 72.394 136.587 73.9392 138.49 73.972Z"
        fill="white"
      />
      <path
        d="M109.515 79.3736C110.47 80.2363 120.34 88.9309 128.653 83.3117C129.926 82.4488 131.554 80.992 133.099 78.4182"
        stroke="white"
        stroke-width="3.44856"
        stroke-miterlimit="10"
      />
      <rect x="194" y="72" width="366" height="194" rx="10.5464" fill="white" />
      <rect
        x="229.697"
        y="105.782"
        width="62.268"
        height="27.7982"
        rx="1.11193"
        fill="#FED500"
        fill-opacity="0.12"
      />
      <rect
        x="300.861"
        y="105.782"
        width="62.268"
        height="27.7982"
        rx="1.11193"
        fill="#3EAA3E"
        fill-opacity="0.12"
      />
      <rect
        x="372.023"
        y="105.782"
        width="62.2681"
        height="27.4276"
        rx="1.11193"
        fill="#E6A052"
        fill-opacity="0.12"
      />
      <rect
        x="443.188"
        y="105.782"
        width="62.2681"
        height="27.4276"
        rx="1.11193"
        fill="#E37D7A"
        fill-opacity="0.12"
      />
      <rect
        x="524.601"
        y="105.968"
        width="20.3854"
        height="14.4551"
        rx="2.03854"
        stroke="#EAEEF0"
        stroke-width="0.370643"
      />
      <rect width="336.544" height="20.756" transform="translate(208.629 85.0254)" fill="white" />
      <path d="M208.764 96.8521H545.308" stroke="#DDDDDD" stroke-width="0.370643" />
      <rect x="241.459" y="86.4038" width="32.694" height="7.38251" rx="1.48257" fill="#D9D9D9" />
      <rect x="208.766" y="86.4038" width="24.2568" height="7.38251" rx="1.48257" fill="#084D6D" />
      <rect x="282.59" y="86.4038" width="35.8579" height="7.38251" rx="1.48257" fill="#D9D9D9" />
      <rect x="326.887" y="86.4038" width="35.8579" height="7.38251" rx="1.48257" fill="#D9D9D9" />
      <rect x="371.182" y="86.4038" width="35.8579" height="7.38251" rx="1.48257" fill="#D9D9D9" />
      <rect x="415.477" y="86.4038" width="35.8579" height="7.38251" rx="1.48257" fill="#D9D9D9" />
      <rect x="460.826" y="86.4038" width="48.5137" height="7.38251" rx="1.48257" fill="#D9D9D9" />
      <rect x="515.851" y="85.5476" width="12.9725" height="9.26608" rx="2.03854" fill="white" />
      <rect
        x="515.851"
        y="85.5476"
        width="12.9725"
        height="9.26608"
        rx="2.03854"
        stroke="#E3E3E3"
        stroke-width="0.370643"
      />
      <rect x="532.16" y="85.5476" width="12.9725" height="9.26608" rx="2.03854" fill="white" />
      <rect
        x="532.16"
        y="85.5476"
        width="12.9725"
        height="9.26608"
        rx="2.03854"
        stroke="#E3E3E3"
        stroke-width="0.370643"
      />
      <rect
        x="209.871"
        y="138.82"
        width="336.173"
        height="117.907"
        rx="1.66789"
        fill="white"
        stroke="#E3E3E3"
        stroke-width="0.370643"
      />
      <rect x="218.256" y="146.518" width="47.459" height="7.38251" rx="1.48257" fill="#939393" />
      <rect x="221.547" y="191.159" width="47.459" height="7.38251" rx="1.48257" fill="#939393" />
      <rect x="221.547" y="204.472" width="172.72" height="7.41286" rx="1.48257" fill="#D9D9D9" />
      <rect x="221.547" y="215.049" width="172.72" height="7.41286" rx="1.48257" fill="#D9D9D9" />
      <rect
        x="468.207"
        y="204.502"
        width="11.1193"
        height="11.1193"
        rx="1.11193"
        fill="#E37D7A"
        fill-opacity="0.12"
      />
      <rect
        x="482.291"
        y="204.502"
        width="11.1193"
        height="11.1193"
        rx="1.11193"
        fill="#E6A052"
        fill-opacity="0.12"
      />
      <rect
        x="496.375"
        y="204.502"
        width="11.1193"
        height="11.1193"
        rx="1.11193"
        fill="#FED500"
        fill-opacity="0.12"
      />
      <rect
        x="510.461"
        y="204.502"
        width="11.1193"
        height="11.1193"
        rx="1.11193"
        fill="#8CCF95"
        fill-opacity="0.12"
      />
      <rect
        x="524.545"
        y="204.502"
        width="11.1193"
        height="11.1193"
        rx="1.11193"
        fill="#3EAA3E"
        fill-opacity="0.12"
      />
      <rect x="509.525" y="231.965" width="29.6515" height="14.7954" rx="2.22386" fill="#5BC4C0" />
      <rect x="222.547" y="163.724" width="312.082" height="17.4202" rx="3.52111" fill="white" />
      <rect
        x="222.547"
        y="163.724"
        width="312.082"
        height="17.4202"
        rx="3.52111"
        stroke="#5BC4BF"
        stroke-width="0.370643"
      />
      <rect x="228.291" y="169.469" width="5.93029" height="5.93029" rx="1" fill="#5BC4BF" />
      <rect
        width="4.44772"
        height="4.44772"
        rx="1"
        transform="matrix(1 0 0 -1 521.471 174.658)"
        fill="#5BC4BF"
      />
      <rect x="241" y="169" width="48" height="7" rx="1.48257" fill="#D9D9D9" />
      <rect x="468.207" y="190.813" width="47.459" height="7.38251" rx="1.48257" fill="#939393" />
      <defs>
        <linearGradient
          id="paint0_linear_24589_17118"
          x1="190.109"
          y1="172.098"
          x2="99.032"
          y2="125.553"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stop-color="#92ADF4" />
          <stop offset="0.46" stop-color="#88A1F2" />
          <stop offset="0.78" stop-color="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_24589_17118"
          x1="149.466"
          y1="169.521"
          x2="48.1708"
          y2="161.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CDD7F2" />
          <stop offset="0.35" stop-color="#AABFFB" />
          <stop offset="0.72" stop-color="#849BF1" />
          <stop offset="1" stop-color="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_24589_17118"
          x1="37.5373"
          y1="201.013"
          x2="63.1816"
          y2="102.368"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stop-color="#92ADF4" />
          <stop offset="0.46" stop-color="#88A1F2" />
          <stop offset="0.78" stop-color="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_24589_17118"
          x1="170.065"
          y1="63.8191"
          x2="62.0203"
          y2="60.3484"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#92ADF4" />
          <stop offset="0.35" stop-color="#8EA8F3" />
          <stop offset="0.72" stop-color="#849BF1" />
          <stop offset="1" stop-color="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_24589_17118"
          x1="115.021"
          y1="33.3496"
          x2="116.017"
          y2="91.1537"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5656DB" />
          <stop offset="1" stop-color="#4949BB" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CopyLinkSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g id="icons">
        <path
          d="M7.05969 8.94005C7.33302 9.20005 7.33302 9.62672 7.05969 9.88672C6.79969 10.1467 6.37302 10.1467 6.11302 9.88672C5.4886 9.26137 5.13789 8.41377 5.13789 7.53005C5.13789 6.64633 5.4886 5.79874 6.11302 5.17338L8.47302 2.81338C9.09837 2.18897 9.94597 1.83826 10.8297 1.83826C11.7134 1.83826 12.561 2.18897 13.1864 2.81338C13.8108 3.43874 14.1615 4.28633 14.1615 5.17005C14.1615 6.05377 13.8108 6.90137 13.1864 7.52672L12.193 8.52005C12.1997 7.97338 12.113 7.42672 11.9264 6.90672L12.2397 6.58672C12.4267 6.40193 12.5753 6.18186 12.6766 5.93925C12.778 5.69664 12.8302 5.43632 12.8302 5.17338C12.8302 4.91045 12.778 4.65013 12.6766 4.40752C12.5753 4.16491 12.4267 3.94483 12.2397 3.76005C12.0549 3.573 11.8348 3.42449 11.5922 3.32312C11.3496 3.22176 11.0893 3.16957 10.8264 3.16957C10.5634 3.16957 10.3031 3.22176 10.0605 3.32312C9.81788 3.42449 9.5978 3.573 9.41302 3.76005L7.05969 6.11338C6.87263 6.29817 6.72412 6.51825 6.62276 6.76086C6.5214 7.00347 6.4692 7.26378 6.4692 7.52672C6.4692 7.78965 6.5214 8.04997 6.62276 8.29258C6.72412 8.53519 6.87263 8.75527 7.05969 8.94005ZM8.93968 6.11338C9.19968 5.85338 9.62635 5.85338 9.88635 6.11338C10.5108 6.73874 10.8615 7.58633 10.8615 8.47005C10.8615 9.35377 10.5108 10.2014 9.88635 10.8267L7.52635 13.1867C6.901 13.8111 6.0534 14.1618 5.16969 14.1618C4.28597 14.1618 3.43837 13.8111 2.81302 13.1867C2.1886 12.5614 1.83789 11.7138 1.83789 10.8301C1.83789 9.94633 2.1886 9.09874 2.81302 8.47338L3.80635 7.48005C3.79969 8.02672 3.88635 8.57338 4.07302 9.10005L3.75968 9.41338C3.57263 9.59817 3.42412 9.81825 3.32276 10.0609C3.2214 10.3035 3.1692 10.5638 3.1692 10.8267C3.1692 11.0897 3.2214 11.35 3.32276 11.5926C3.42412 11.8352 3.57263 12.0553 3.75968 12.2401C3.94447 12.4271 4.16455 12.5756 4.40716 12.677C4.64977 12.7783 4.91008 12.8305 5.17302 12.8305C5.43595 12.8305 5.69627 12.7783 5.93888 12.677C6.18149 12.5756 6.40157 12.4271 6.58635 12.2401L8.93968 9.88672C9.12674 9.70193 9.27525 9.48186 9.37661 9.23925C9.47797 8.99664 9.53017 8.73632 9.53017 8.47338C9.53017 8.21045 9.47797 7.95013 9.37661 7.70752C9.27525 7.46491 9.12674 7.24484 8.93968 7.06005C8.87494 6.99938 8.82333 6.92607 8.78804 6.84465C8.75276 6.76324 8.73455 6.67545 8.73455 6.58672C8.73455 6.49799 8.75276 6.4102 8.78804 6.32878C8.82333 6.24737 8.87494 6.17406 8.93968 6.11338Z"
          fill="#666666"
        />
      </g>
    </svg>
  );
}

export default function NoAttachmentsSVG() {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M95.0237 41.2065H8.02917C6.77541 41.2065 5.75903 42.2229 5.75903 43.4767V100.016C5.75903 101.27 6.77541 102.286 8.02917 102.286H95.0237C96.2775 102.286 97.2938 101.27 97.2938 100.016V43.4767C97.2938 42.2229 96.2775 41.2065 95.0237 41.2065Z"
        fill="white"
      />
      <path
        d="M96.7358 42.9186H9.74133C8.48757 42.9186 7.47119 43.935 7.47119 45.1887V101.728C7.47119 102.982 8.48757 103.998 9.74133 103.998H96.7358C97.9896 103.998 99.006 102.982 99.006 101.728V45.1887C99.006 43.935 97.9896 42.9186 96.7358 42.9186Z"
        fill="#E3E3E3"
      />
      <path
        d="M94.4708 102.629H8.58056C6.83601 102.629 5.41675 101.209 5.41675 99.4648V44.0297C5.41675 43.8413 5.57083 43.6873 5.75915 43.6873C5.94747 43.6873 6.10156 43.8413 6.10156 44.0297V99.4648C6.10156 100.833 7.21437 101.944 8.58056 101.944H94.4708C95.8387 101.944 96.9498 100.831 96.9498 99.4648V44.0297C96.9498 42.6618 95.837 41.5507 94.4708 41.5507H47.5718C47.3835 41.5507 47.2294 41.3966 47.2294 41.2082C47.2294 41.0199 47.3835 40.8658 47.5718 40.8658H94.4708C96.2154 40.8658 97.6346 42.2851 97.6346 44.0297V99.4648C97.6346 101.209 96.2154 102.629 94.4708 102.629Z"
        fill="#CFCFCF"
      />
      <path
        d="M45.4598 9.36829L37.7763 55.3805C37.5897 56.5002 38.3481 57.5599 39.4729 57.7482L80.9294 64.6699C82.0525 64.8582 83.1157 64.1015 83.3023 62.9819L84.499 55.8102L85.1256 51.852L92.4222 8.15789C92.6088 7.03823 91.8504 5.97849 90.7256 5.79017L58.1031 0.342529L45.4615 9.35802V9.36829H45.4598Z"
        fill="white"
      />
      <path
        d="M81.2711 65.0396C81.1393 65.0396 81.0075 65.0293 80.8722 65.007L39.4157 58.0853C38.1077 57.8662 37.2209 56.6284 37.4383 55.3239L45.1236 9.31164C45.1236 9.31164 45.1236 9.30822 45.1236 9.30651V9.29624C45.1407 9.20892 45.1903 9.13017 45.2639 9.07881L57.9055 0.0633176C57.9791 0.010245 58.0716 -0.0102993 58.1606 0.00510891L90.7831 5.45275C91.4166 5.5589 91.9712 5.90473 92.3445 6.42518C92.7177 6.94735 92.8649 7.5825 92.7605 8.21424L85.4639 51.9084L84.839 55.8631L83.6406 63.0365C83.4454 64.2075 82.425 65.0396 81.2711 65.0396ZM45.7776 9.55475L38.1163 55.4351C37.9605 56.3665 38.5956 57.2533 39.5304 57.4091L80.9869 64.3308C81.9234 64.4883 82.8102 63.8549 82.966 62.9235L84.1627 55.7519L84.7876 51.7971L92.0842 8.09953C92.1596 7.64756 92.0534 7.19388 91.7881 6.82237C91.521 6.44915 91.1238 6.20262 90.6701 6.12729L58.188 0.703613L45.7776 9.55475Z"
        fill="#CFCFCF"
      />
      <path
        d="M54.5363 11.2188C54.3994 11.2188 54.2607 11.2069 54.122 11.1846L45.401 9.72768C45.264 9.70542 45.1545 9.6027 45.1236 9.46745C45.0928 9.3322 45.1459 9.19182 45.2589 9.11135L57.9278 0.0667586C58.0408 -0.0137063 58.1915 -0.0188424 58.3079 0.0547744C58.426 0.128391 58.4877 0.265353 58.4637 0.402314L57.0068 9.12334C56.803 10.3474 55.7364 11.2188 54.5346 11.2188H54.5363ZM46.3289 9.18839L54.235 10.5084C54.7144 10.5888 55.1972 10.4775 55.5943 10.1933C55.9898 9.91087 56.2535 9.48971 56.3339 9.01034L57.6539 1.10424L46.3306 9.18668L46.3289 9.18839Z"
        fill="#CFCFCF"
      />
      <path
        d="M73.745 36.6303C73.7176 36.6303 73.6885 36.6286 73.6594 36.6235L54.555 33.4323C54.276 33.3861 54.0859 33.1207 54.1339 32.8416C54.1801 32.5626 54.4437 32.3726 54.7245 32.4205L73.8289 35.6117C74.108 35.6579 74.298 35.9233 74.2501 36.2023C74.2073 36.454 73.9899 36.6321 73.7433 36.6321L73.745 36.6303Z"
        fill="#E3E3E3"
      />
      <path
        d="M80.0572 50.5216C80.0384 50.5216 80.0196 50.5216 80.0007 50.5165L44.0432 44.5107C43.8566 44.4799 43.7299 44.3036 43.7624 44.117C43.7932 43.9304 43.9696 43.8054 44.1562 43.8362L80.1137 49.842C80.3003 49.8728 80.427 50.0491 80.3945 50.2357C80.3671 50.4035 80.2216 50.5216 80.0572 50.5216Z"
        fill="#CFCFCF"
      />
      <path
        d="M80.9029 45.4592C80.8841 45.4592 80.8653 45.4592 80.8464 45.4541L44.8889 39.4483C44.7023 39.4175 44.5756 39.2412 44.6081 39.0545C44.6389 38.8679 44.8153 38.7412 45.0019 38.7738L80.9594 44.7795C81.146 44.8104 81.2727 44.9867 81.2402 45.1733C81.2128 45.3411 81.0673 45.4592 80.9029 45.4592Z"
        fill="#CFCFCF"
      />
      <path
        d="M61.3689 52.6035C61.35 52.6035 61.3312 52.6035 61.3124 52.5983L43.1975 49.5732C43.0109 49.5424 42.8842 49.366 42.9167 49.1794C42.9475 48.9928 43.1239 48.8661 43.3105 48.8987L61.4254 51.9238C61.612 51.9546 61.7387 52.1309 61.7061 52.3176C61.6787 52.4853 61.5332 52.6035 61.3689 52.6035Z"
        fill="#CFCFCF"
      />
      <path
        d="M65.4422 20.1814C66.038 20.1814 66.668 20.2293 67.3271 20.3389C71.864 21.0973 74.1084 23.9872 74.2009 24.1087C74.3156 24.2594 74.2865 24.4734 74.1358 24.5881C73.9852 24.7028 73.7712 24.6737 73.6565 24.523C73.6359 24.4957 71.4719 21.7239 67.2141 21.0134C62.9615 20.3029 59.9398 22.4344 59.909 22.4549C59.7549 22.5645 59.5409 22.5303 59.4313 22.3779C59.32 22.2255 59.3543 22.0115 59.5084 21.9002C59.6213 21.8181 61.9326 20.1797 65.4405 20.1797L65.4422 20.1814Z"
        fill="#CFCFCF"
      />
      <path
        d="M59.1689 16.9353C59.2647 16.36 58.8761 15.8156 58.3009 15.7197C57.7256 15.6239 57.1812 16.0125 57.0853 16.5877C56.9895 17.163 57.3781 17.7074 57.9533 17.8033C58.5286 17.8991 59.073 17.5105 59.1689 16.9353Z"
        fill="#CFCFCF"
      />
      <path
        d="M77.3627 19.9741C77.4586 19.3988 77.07 18.8544 76.4947 18.7585C75.9195 18.6627 75.3751 19.0513 75.2792 19.6265C75.1833 20.2018 75.5719 20.7462 76.1472 20.8421C76.7224 20.9379 77.2668 20.5493 77.3627 19.9741Z"
        fill="#CFCFCF"
      />
      <path
        d="M96.3849 37.6113C96.3541 37.6113 96.3215 37.6079 96.2907 37.5976C89.0934 35.5432 88.4788 29.7669 88.6551 28.7157C88.6859 28.5291 88.8623 28.4024 89.0489 28.4349C89.2355 28.4657 89.3605 28.6421 89.3297 28.8287C89.3194 28.8869 89.0883 34.8293 96.4773 36.9385C96.6588 36.9899 96.765 37.1799 96.7119 37.3614C96.6691 37.512 96.5321 37.6096 96.3832 37.6096L96.3849 37.6113Z"
        fill="#CFCFCF"
      />
      <path
        d="M43.4458 21.7734C43.4235 21.7734 43.4013 21.7717 43.3773 21.7666C43.3225 21.7563 37.6284 20.0871 34.2214 12.9565C34.1393 12.7853 34.2129 12.5816 34.3824 12.4994C34.5536 12.4172 34.7573 12.4908 34.8395 12.6603C37.7585 18.7705 42.6685 20.9242 43.5143 21.0954C43.6992 21.1331 43.819 21.3129 43.7814 21.4995C43.7488 21.6621 43.605 21.7734 43.4458 21.7734Z"
        fill="#CFCFCF"
      />
      <path
        d="M57.5015 66.0873C57.4827 66.0873 57.4639 66.0873 57.445 66.0822C57.2584 66.0514 57.1317 65.8751 57.1643 65.6884L57.9741 60.8366C58.0049 60.65 58.1812 60.525 58.3678 60.5558C58.5544 60.5866 58.6811 60.763 58.6486 60.9496L57.8388 65.8014C57.8114 65.9692 57.6659 66.0873 57.5015 66.0873Z"
        fill="#CFCFCF"
      />
      <path
        d="M61.2813 66.7174C61.2625 66.7174 61.2437 66.7174 61.2248 66.7123C61.0382 66.6815 60.9115 66.5051 60.9441 66.3185L61.7538 61.4667C61.7847 61.28 61.961 61.1534 62.1476 61.1859C62.3342 61.2167 62.4609 61.393 62.4284 61.5796L61.6186 66.4315C61.5912 66.5993 61.4457 66.7174 61.2813 66.7174Z"
        fill="#CFCFCF"
      />
      <path
        d="M97.2938 50.6056H54.519C53.6921 50.6056 52.908 50.2427 52.3722 49.6144L41.7183 37.1218C41.1824 36.4934 40.3966 36.1305 39.5714 36.1305H8.58044C7.0225 36.1305 5.75903 37.394 5.75903 38.9519V99.4632C5.75903 101.021 7.0225 102.285 8.58044 102.285H94.4707C96.0286 102.285 97.2921 101.021 97.2921 99.4632V50.6039L97.2938 50.6056Z"
        fill="white"
      />
      <path
        d="M99.006 52.3175H56.2312C55.4043 52.3175 54.6202 51.9546 54.0843 51.3263L43.4304 38.8337C42.8946 38.2054 42.1088 37.8424 41.2836 37.8424H10.2926C8.73466 37.8424 7.47119 39.1059 7.47119 40.6638V101.175C7.47119 102.733 8.73466 103.997 10.2926 103.997H96.1829C97.7408 103.997 99.0043 102.733 99.0043 101.175V52.3158L99.006 52.3175Z"
        fill="#EAEAEA"
      />
      <path
        d="M94.4708 102.63H8.58056C6.83601 102.63 5.41675 101.211 5.41675 99.4649V38.9553C5.41675 37.2108 6.83601 35.7915 8.58056 35.7915H39.5698C40.4977 35.7915 41.376 36.1973 41.9769 36.9026L52.6308 49.3952C53.1033 49.9482 53.7898 50.2666 54.5174 50.2666H97.2922C97.4806 50.2666 97.6346 50.4207 97.6346 50.609V99.4683C97.6346 101.213 96.2154 102.632 94.4708 102.632V102.63ZM8.58056 36.4746C7.21266 36.4746 6.10156 37.5874 6.10156 38.9536V99.4649C6.10156 100.833 7.21437 101.944 8.58056 101.944H94.4708C95.8387 101.944 96.9498 100.831 96.9498 99.4649V50.948H54.5174C53.5895 50.948 52.7113 50.5423 52.1103 49.8369L41.4565 37.3443C40.9839 36.7913 40.2974 36.4729 39.5698 36.4729H8.58056V36.4746Z"
        fill="#CFCFCF"
      />
      <path
        d="M92.6818 89.8228C92.4934 89.8228 92.3394 89.6687 92.3394 89.4804V87.7975C92.3394 87.6092 92.4934 87.4551 92.6818 87.4551C92.8701 87.4551 93.0242 87.6092 93.0242 87.7975V89.4804C93.0242 89.6687 92.8701 89.8228 92.6818 89.8228Z"
        fill="#CFCFCF"
      />
      <path
        d="M92.6818 92.4764C92.4934 92.4764 92.3394 92.3223 92.3394 92.134V91.1068C92.3394 90.9185 92.4934 90.7644 92.6818 90.7644C92.8701 90.7644 93.0242 90.9185 93.0242 91.1068V92.134C93.0242 92.3223 92.8701 92.4764 92.6818 92.4764Z"
        fill="#CFCFCF"
      />
      <path
        d="M90.1445 99.2971H87.7596C87.5713 99.2971 87.4172 99.143 87.4172 98.9547C87.4172 98.7663 87.5713 98.6123 87.7596 98.6123H90.1445C91.3549 98.6123 92.3393 97.6279 92.3393 96.4175V93.6748C92.3393 93.4865 92.4934 93.3324 92.6817 93.3324C92.87 93.3324 93.0241 93.4865 93.0241 93.6748V96.4175C93.0241 98.0062 91.7315 99.2971 90.1445 99.2971Z"
        fill="#CFCFCF"
      />
      <path
        d="M85.4758 99.2971H82.9215C82.7332 99.2971 82.5791 99.143 82.5791 98.9547C82.5791 98.7664 82.7332 98.6123 82.9215 98.6123H85.4758C85.6642 98.6123 85.8182 98.7664 85.8182 98.9547C85.8182 99.143 85.6642 99.2971 85.4758 99.2971Z"
        fill="#CFCFCF"
      />
      <path
        d="M27.5194 59.0109C33.5885 59.0109 37.1306 62.2791 37.2796 62.4178C37.4165 62.5479 37.4234 62.7636 37.295 62.9023C37.1649 63.0393 36.9492 63.0461 36.8105 62.9177C36.7762 62.8852 33.306 59.6957 27.5194 59.6957C21.7327 59.6957 18.2145 63.1848 18.1786 63.219C18.045 63.3543 17.8293 63.3543 17.6941 63.2207C17.5605 63.0872 17.5588 62.8715 17.6907 62.7362C17.8413 62.5839 21.44 59.0092 27.5176 59.0092L27.5194 59.0109Z"
        fill="#CFCFCF"
      />
      <path
        d="M15.2804 56.4617C16.0445 56.3303 16.5574 55.6043 16.426 54.8402C16.2945 54.0761 15.5685 53.5632 14.8044 53.6946C14.0403 53.8261 13.5274 54.552 13.6589 55.3162C13.7903 56.0803 14.5163 56.5931 15.2804 56.4617Z"
        fill="#CFCFCF"
      />
      <path
        d="M39.7898 56.4673C40.5543 56.3383 41.0695 55.6139 40.9404 54.8494C40.8114 54.0849 40.087 53.5697 39.3225 53.6987C38.558 53.8278 38.0428 54.5521 38.1719 55.3167C38.3009 56.0812 39.0253 56.5963 39.7898 56.4673Z"
        fill="#CFCFCF"
      />
    </svg>
  );
}

export function NoFormResponsesSVG() {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19514_18450)">
        <path
          d="M85.4799 21.487V94.6849C85.4782 96.551 83.9677 98.0636 82.1053 98.062H13.373C11.5105 98.0603 10 96.5477 10 94.6833V82.7387L10.0573 76.1557V3.37867C10.0589 1.51259 11.5695 0 13.4319 0H80.2134C83.1216 0 85.4799 2.37082 85.4799 5.29243V18.0327V21.4887V21.487Z"
          fill="#E5E5E5"
        />
        <path
          d="M87.2904 22.5905V95.7884C87.2888 97.6545 85.7782 99.1671 83.9158 99.1655H15.1835C13.3211 99.1638 11.8105 97.6512 11.8105 95.7852V83.8406L11.8678 77.2576V4.48054C11.8695 2.61446 13.38 1.10187 15.2424 1.10352H82.024C84.9321 1.10352 87.2904 3.47434 87.2904 6.39594V19.1346V22.5905Z"
          fill="#F9F9F9"
        />
        <path
          d="M86.8945 22.6973C86.8945 25.6846 86.8945 28.672 86.8945 31.6594C86.8945 38.5564 86.8945 45.4519 86.8945 52.349C86.8945 60.129 86.8945 67.9089 86.8945 75.6889C86.8945 81.3398 86.8945 86.9906 86.8945 92.6415C86.8945 93.7003 86.9174 94.7607 86.8945 95.8195C86.8585 97.4604 85.7767 98.9204 84.0567 98.9845C83.7605 98.996 83.461 98.9845 83.1648 98.9845C78.5218 98.9845 73.8789 98.9845 69.236 98.9845C61.6669 98.9845 54.0978 98.9845 46.5287 98.9845C39.4129 98.9845 32.2988 98.9845 25.183 98.9845C21.9148 98.9845 18.6237 99.1012 15.3571 98.9845C13.3458 98.9121 12.2067 97.2171 12.2067 95.3411C12.2067 93.845 12.2067 92.3488 12.2067 90.8543C12.2067 88.278 12.1903 85.7 12.2116 83.1236C12.2411 79.7598 12.264 76.3959 12.264 73.032C12.264 67.0885 12.264 61.145 12.264 55.2015C12.264 47.4035 12.264 39.6054 12.264 31.8073C12.264 25.124 12.264 18.4423 12.264 11.7589C12.264 9.82215 12.264 7.88373 12.264 5.94695C12.264 4.19596 12.1871 2.11122 14.2704 1.4174C15.2245 1.10008 16.5076 1.28916 17.4912 1.28916C19.7562 1.28916 22.0195 1.28916 24.2845 1.28916C31.3938 1.28916 38.503 1.28916 45.6122 1.28916C53.1306 1.28916 60.6506 1.28916 68.1689 1.28916C72.5451 1.28916 76.9229 1.28916 81.2991 1.28916C81.8506 1.28916 82.3776 1.28916 82.9258 1.41904C85.3299 1.98462 86.8667 4.18117 86.8961 6.60131C86.9321 9.7383 86.8961 12.8769 86.8961 16.0139C86.8961 18.2433 86.8961 20.4711 86.8961 22.7005C86.8961 22.8682 87.6866 22.7449 87.6866 22.4885C87.6866 17.0925 87.7831 11.6899 87.6866 6.29551C87.6408 3.70602 85.798 1.47659 83.245 1.01788C82.7294 0.925808 82.2156 0.925808 81.6951 0.925808C80.124 0.925808 78.5546 0.925808 76.9835 0.925808C70.4732 0.925808 63.963 0.925808 57.4527 0.925808C49.5842 0.925808 41.7156 0.925808 33.8453 0.925808C28.3776 0.925808 22.9082 0.925808 17.4404 0.925808C16.1852 0.925808 14.8121 0.782769 13.6436 1.32369C12.2934 1.94681 11.4948 3.20292 11.4752 4.6892C11.4703 5.06406 11.4752 5.44056 11.4752 5.81542C11.4752 10.6393 11.4752 15.4631 11.4752 20.2853C11.4752 28.0061 11.4752 35.7253 11.4752 43.4461C11.4752 50.8397 11.4752 58.2333 11.4752 65.6269C11.4752 69.4709 11.4817 73.3132 11.4752 77.1571C11.467 82.0336 11.4179 86.9101 11.4179 91.7882C11.4179 93.1216 11.3917 94.4599 11.4179 95.7932C11.4588 97.8484 13.0004 99.3051 15.0232 99.3511C15.9413 99.3725 16.8627 99.3511 17.7808 99.3511C23.4908 99.3511 29.2008 99.3511 34.9091 99.3511C42.8104 99.3511 50.7117 99.3511 58.6131 99.3511C65.1413 99.3511 71.6696 99.3511 78.1978 99.3511C79.8327 99.3511 81.4693 99.3511 83.1042 99.3511C83.3923 99.3511 83.6852 99.3626 83.9732 99.3445C85.9747 99.2163 87.6293 97.7317 87.685 95.6732C87.7717 92.4474 87.685 89.2085 87.685 85.9828C87.685 78.8473 87.685 71.7102 87.685 64.5747C87.685 56.7174 87.685 48.8618 87.685 41.0045C87.685 35.6118 87.685 30.2175 87.685 24.8248C87.685 24.0454 87.685 23.2678 87.685 22.4885C87.685 22.3208 86.8945 22.4441 86.8945 22.7005V22.6973Z"
          fill="#CFCFCF"
        />
        <path
          d="M90.5639 24.2346V97.4325C90.5622 99.2986 89.0517 100.811 87.1893 100.81H18.4569C16.5945 100.808 15.084 99.2953 15.084 97.4292V85.4847L15.1413 78.9016V6.12458C15.1429 4.25851 16.6534 2.74592 18.5159 2.74756H85.2974C88.2056 2.74756 90.5639 5.11838 90.5639 8.03999V20.7786V24.2346Z"
          fill="#F9F9F9"
        />
        <path
          d="M88.4475 23.9186V97.5144C88.4458 99.3344 86.9909 100.809 85.1956 100.809H18.3322C16.5369 100.808 15.082 99.3328 15.082 97.5127V85.8625L15.1377 79.4422V8.454C15.1393 6.63396 16.5942 5.15918 18.3895 5.15918H85.5278C87.1415 5.15918 88.4491 6.45639 88.4491 8.05283V23.917L88.4475 23.9186Z"
          fill="white"
        />
        <path
          d="M90.1679 24.3413C90.1679 27.3287 90.1679 30.316 90.1679 33.3034C90.1679 40.2005 90.1679 47.0959 90.1679 53.993C90.1679 61.773 90.1679 69.553 90.1679 77.333C90.1679 82.9838 90.1679 88.6347 90.1679 94.2855C90.1679 95.3443 90.1908 96.4048 90.1679 97.4636C90.1319 99.1044 89.0502 100.564 87.3301 100.629C87.0339 100.64 86.7344 100.629 86.4382 100.629C81.7953 100.629 77.1524 100.629 72.5094 100.629C64.9403 100.629 57.3712 100.629 49.8021 100.629C42.6864 100.629 35.5722 100.629 28.4564 100.629C25.1882 100.629 21.8971 100.745 18.6305 100.629C16.6192 100.556 15.4801 98.8611 15.4801 96.9852C15.4801 95.489 15.4801 93.9929 15.4801 92.4983C15.4801 89.922 15.4638 87.344 15.4851 84.7677C15.5145 81.4038 15.5374 78.0399 15.5374 74.6761C15.5374 68.7326 15.5374 62.7891 15.5374 56.8456C15.5374 49.0475 15.5374 41.2494 15.5374 33.4514C15.5374 26.768 15.5374 20.0863 15.5374 13.403C15.5374 11.4662 15.5374 9.52777 15.5374 7.591C15.5374 5.84001 15.4605 3.75526 17.5439 3.06144C18.498 2.74413 19.781 2.9332 20.7646 2.9332C23.0296 2.9332 25.293 2.9332 27.558 2.9332C34.6672 2.9332 41.7764 2.9332 48.8857 2.9332C56.404 2.9332 63.924 2.9332 71.4424 2.9332C75.8186 2.9332 80.1964 2.9332 84.5725 2.9332C85.124 2.9332 85.651 2.9332 86.1993 3.06309C88.6034 3.62866 90.1401 5.82521 90.1696 8.24536C90.2056 11.3823 90.1696 14.521 90.1696 17.658C90.1696 19.8874 90.1696 22.1152 90.1696 24.3446C90.1696 24.5123 90.96 24.389 90.96 24.1325C90.96 18.7365 91.0566 13.3339 90.96 7.93955C90.9142 5.35006 89.0714 3.12063 86.5184 2.66192C86.0029 2.56985 85.489 2.56985 84.9686 2.56985C83.3975 2.56985 81.828 2.56985 80.2569 2.56985C73.7467 2.56985 67.2364 2.56985 60.7262 2.56985C52.8576 2.56985 44.989 2.56985 37.1188 2.56985C31.651 2.56985 26.1816 2.56985 20.7139 2.56985C19.4586 2.56985 18.0856 2.42681 16.917 2.96773C15.5669 3.59085 14.7682 4.84696 14.7486 6.33324C14.7437 6.7081 14.7486 7.08461 14.7486 7.45947C14.7486 12.2833 14.7486 17.1072 14.7486 21.9294C14.7486 29.6502 14.7486 37.3693 14.7486 45.0901C14.7486 52.4837 14.7486 59.8773 14.7486 67.271C14.7486 71.1149 14.7552 74.9572 14.7486 78.8012C14.7404 83.6776 14.6913 88.5541 14.6913 93.4322C14.6913 94.7656 14.6651 96.1039 14.6913 97.4373C14.7322 99.4924 16.2739 100.949 18.2967 100.995C19.2148 101.017 20.1362 100.995 21.0543 100.995C26.7642 100.995 32.4742 100.995 38.1825 100.995C46.0839 100.995 53.9852 100.995 61.8865 100.995C68.4147 100.995 74.943 100.995 81.4712 100.995C83.1062 100.995 84.7427 100.995 86.3777 100.995C86.6657 100.995 86.9586 101.007 87.2467 100.989C89.2482 100.86 90.9027 99.3757 90.9584 97.3173C91.0451 94.0915 90.9584 90.8526 90.9584 87.6268C90.9584 80.4913 90.9584 73.3542 90.9584 66.2187C90.9584 58.3615 90.9584 50.5058 90.9584 42.6486C90.9584 37.2559 90.9584 31.8615 90.9584 26.4688C90.9584 25.6895 90.9584 24.9118 90.9584 24.1325C90.9584 23.9648 90.1679 24.0881 90.1679 24.3446V24.3413Z"
          fill="#CFCFCF"
        />
        <path
          d="M30.7071 43.3785H83.5681C84.005 43.3785 84.1867 42.8359 83.6483 42.8359H30.7873C30.3504 42.8359 30.1687 43.3785 30.7071 43.3785Z"
          fill="#CFCFCF"
        />
        <path
          d="M22.1974 48.3108H81.0645C81.8468 48.3108 82.6863 48.3979 83.4653 48.3108C83.4997 48.3075 83.5357 48.3108 83.5701 48.3108C84.007 48.3108 84.1887 47.7682 83.6503 47.7682H24.7831C24.0009 47.7682 23.1613 47.6811 22.3823 47.7682C22.3479 47.7715 22.3119 47.7682 22.2776 47.7682C21.8406 47.7682 21.6589 48.3108 22.1974 48.3108Z"
          fill="#CFCFCF"
        />
        <path
          d="M22.1974 53.2432H73.9127C74.3497 53.2432 74.5313 52.7007 73.9929 52.7007H22.2776C21.8406 52.7007 21.6589 53.2432 22.1974 53.2432Z"
          fill="#CFCFCF"
        />
        <path
          d="M30.0372 58.1754H83.5675C84.0045 58.1754 84.1861 57.6328 83.6477 57.6328H30.1174C29.6804 57.6328 29.4988 58.1754 30.0372 58.1754Z"
          fill="#CFCFCF"
        />
        <path
          d="M22.1974 63.1081H81.0645C81.8468 63.1081 82.6863 63.1953 83.4653 63.1081C83.4997 63.1049 83.5357 63.1081 83.5701 63.1081C84.007 63.1081 84.1887 62.5656 83.6503 62.5656H24.7831C24.0009 62.5656 23.1613 62.4784 22.3823 62.5656C22.3479 62.5689 22.3119 62.5656 22.2776 62.5656C21.8406 62.5656 21.6589 63.1081 22.1974 63.1081Z"
          fill="#CFCFCF"
        />
        <path
          d="M22.1974 68.0401H73.569C74.006 68.0401 74.1877 67.4976 73.6492 67.4976H22.2776C21.8406 67.4976 21.6589 68.0401 22.1974 68.0401Z"
          fill="#CFCFCF"
        />
        <path
          d="M67.2159 32.3794H38.941C38.2929 32.3794 37.7676 32.9072 37.7676 33.5582V33.5599C37.7676 34.2109 38.2929 34.7387 38.941 34.7387H67.2159C67.8639 34.7387 68.3893 34.2109 68.3893 33.5599V33.5582C68.3893 32.9072 67.8639 32.3794 67.2159 32.3794Z"
          fill="#EFEFEF"
        />
      </g>
      <defs>
        <clipPath id="clip0_19514_18450">
          <rect width="81" height="101" fill="white" transform="translate(10)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ZoomOutSVG() {
  return (
    <svg
      width="24"
      height="25.5"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33301 7.50005C1.33308 6.59644 1.54925 5.70596 1.96347 4.90288C2.37769 4.09981 2.97795 3.40744 3.71418 2.88354C4.4504 2.35963 5.30124 2.01939 6.1957 1.89119C7.09017 1.76298 8.00232 1.85055 8.85606 2.14657C9.70981 2.44259 10.4804 2.93848 11.1035 3.59287C11.7266 4.24727 12.1842 5.04118 12.4381 5.90839C12.692 6.7756 12.7348 7.69094 12.563 8.57806C12.3911 9.46518 12.0096 10.2983 11.4503 11.008L13.885 13.4427C14.0064 13.5684 14.0736 13.7369 14.0721 13.9116C14.0706 14.0864 14.0005 14.2537 13.8769 14.3773C13.7533 14.5009 13.5861 14.571 13.4113 14.5725C13.2365 14.574 13.0681 14.5068 12.9423 14.3854L10.5077 11.9507C9.67209 12.6094 8.66794 13.0195 7.61016 13.1341C6.55237 13.2487 5.48369 13.0632 4.5264 12.5989C3.56912 12.1345 2.76191 11.41 2.19716 10.5082C1.63241 9.60653 1.33294 8.56402 1.33301 7.50005ZM4.66634 6.83338C4.48953 6.83338 4.31996 6.90362 4.19494 7.02864C4.06991 7.15367 3.99967 7.32324 3.99967 7.50005C3.99967 7.67686 4.06991 7.84643 4.19494 7.97145C4.31996 8.09648 4.48953 8.16671 4.66634 8.16671H9.33301C9.50982 8.16671 9.67939 8.09648 9.80441 7.97145C9.92944 7.84643 9.99967 7.67686 9.99967 7.50005C9.99967 7.32324 9.92944 7.15367 9.80441 7.02864C9.67939 6.90362 9.50982 6.83338 9.33301 6.83338H4.66634Z"
        fill="#666666"
      />
    </svg>
  );
}

export function ZoomInSVG() {
  return (
    <svg
      width="24"
      height="25.5"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00017 1.83337C6.09656 1.83345 5.20608 2.04962 4.40301 2.46384C3.59994 2.87806 2.90756 3.47832 2.38366 4.21454C1.85976 4.95077 1.51951 5.80161 1.39131 6.69607C1.26311 7.59053 1.35067 8.50269 1.64669 9.35643C1.94271 10.2102 2.4386 10.9807 3.09299 11.6039C3.74739 12.227 4.54131 12.6846 5.40851 12.9384C6.27572 13.1923 7.19106 13.2351 8.07818 13.0633C8.9653 12.8915 9.79847 12.51 10.5082 11.9507L12.9428 14.3854C13.0686 14.5068 13.237 14.574 13.4118 14.5725C13.5866 14.571 13.7538 14.5009 13.8774 14.3773C14.001 14.2536 14.0711 14.0864 14.0726 13.9116C14.0741 13.7368 14.0069 13.5684 13.8855 13.4427L11.4508 11.008C12.1095 10.1725 12.5196 9.16831 12.6342 8.11052C12.7489 7.05274 12.5634 5.98405 12.099 5.02677C11.6346 4.06948 10.9101 3.26228 10.0084 2.69753C9.10665 2.13278 8.06415 1.8333 7.00017 1.83337ZM4.00017 7.50004C4.00017 7.32323 4.07041 7.15366 4.19543 7.02864C4.32046 6.90361 4.49002 6.83337 4.66684 6.83337H6.3335V5.16671C6.3335 4.9899 6.40374 4.82033 6.52876 4.6953C6.65379 4.57028 6.82336 4.50004 7.00017 4.50004C7.17698 4.50004 7.34655 4.57028 7.47157 4.6953C7.5966 4.82033 7.66684 4.9899 7.66684 5.16671V6.83337H9.3335C9.51031 6.83337 9.67988 6.90361 9.80491 7.02864C9.92993 7.15366 10.0002 7.32323 10.0002 7.50004C10.0002 7.67685 9.92993 7.84642 9.80491 7.97145C9.67988 8.09647 9.51031 8.16671 9.3335 8.16671H7.66684V9.83337C7.66684 10.0102 7.5966 10.1798 7.47157 10.3048C7.34655 10.4298 7.17698 10.5 7.00017 10.5C6.82336 10.5 6.65379 10.4298 6.52876 10.3048C6.40374 10.1798 6.3335 10.0102 6.3335 9.83337V8.16671H4.66684C4.49002 8.16671 4.32046 8.09647 4.19543 7.97145C4.07041 7.84642 4.00017 7.67685 4.00017 7.50004Z"
        fill="#666666"
      />
    </svg>
  );
}
